import {QuestionEdgeType} from "../../definitions/types";
import {QuestionModel} from "./questionModel";

export class QuestionEdgeModel {
    private readonly _cursor: string;
    private readonly _node: QuestionModel;

    constructor(questionEdgeType: QuestionEdgeType) {
        this._cursor = questionEdgeType.cursor;
        this._node = new QuestionModel(questionEdgeType.node);
    }

    /**
     * @method cursor
     * @description Gets the cursor for the question edge.
     * @returns {string}
     */
    public get cursor(): string {
        return this._cursor;
    }

    /**
     * @method node
     * @description Gets the question for the question edge.
     * @returns {QuestionModel}
     */
    public get node(): QuestionModel {
        return this._node;
    }
}